import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { tap } from 'rxjs';
import { Router } from '@angular/router';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const token = authService.getToken();

  // Add token to requests to backend API
  if (token && (req.url.includes('/api/') || req.url.includes('localhost:3000'))) {
    const clonedReq = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });

    return next(clonedReq).pipe(
      tap({
        error: (error) => {
          // Only logout on authentication errors for non-verify endpoints
          // The verify endpoint handles its own logout logic
          if ((error.status === 401 || error.status === 403) && !req.url.includes('/auth/verify')) {
            authService.logout();
          }
        }
      })
    );
  }

  return next(req);
};
